import { render } from "./Information.vue?vue&type=template&id=4ef1e238"
import script from "./Information.vue?vue&type=script&lang=js"
export * from "./Information.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__